export enum STEPS {
  ENTER_EMAILS = 'ENTER_EMAILS',
  CONFIRM_PASSWORD = 'CONFIRM_PASSWORD',
}
